import { useState } from 'react';
import { PDFViewer } from '@react-pdf/renderer';
import FichaRupturaPDF from '../components/FichaRupturaPDF';
import { LOGO_EXEMPLO, ASSINATURA_EXEMPLO } from '../components/pdf/exemploImagens';

// Página de desenvolvimento: mostra o PDF da "Ficha de Ruptura" ao vivo (hot reload),
// sem precisar de backend. Acesse em /app/dev-pdf-preview-ficha-ruptura. Não aparece no menu.
// Cobre: múltiplas empresas/obras no cabeçalho, CP sem idade/data de moldagem (campos em
// branco) e quebra de página com muitos CPs.

const dataRupturaMock = '15/08/2026';
const empresasMock = ['Construtora Exemplo Ltda', 'Construtora Modelo S.A.'];
const obrasMock = ['Edifício Aurora', 'Residencial Bosque Verde'];

const resultadosMock = [
  {
    id: 'cp-1',
    etiqueta: '644',
    idadeRuptura: 7,
    dataMoldagem: '2026-08-08',
    obra: 'Edifício Aurora',
    tensaoEsperada: 24.5,
  },
  {
    id: 'cp-2',
    etiqueta: '2378',
    idadeRuptura: 28,
    dataMoldagem: '2026-07-18',
    obra: 'Edifício Aurora',
    tensaoEsperada: 30.2,
  },
  {
    id: 'cp-3',
    etiqueta: '2379',
    idadeRuptura: 28,
    dataMoldagem: '2026-07-18',
    obra: 'Residencial Bosque Verde',
    tensaoEsperada: 30.2,
  },
  // CP sem idade/data de moldagem (dados incompletos) — valida campos em branco na tabela.
  {
    id: 'cp-4',
    etiqueta: '2401',
    idadeRuptura: '',
    dataMoldagem: null,
    obra: 'Residencial Bosque Verde',
    tensaoEsperada: null,
  },
  ...Array.from({ length: 14 }, (_, i) => ({
    id: `cp-extra-${i}`,
    etiqueta: String(2500 + i),
    idadeRuptura: 28,
    dataMoldagem: '2026-07-18',
    obra: i % 2 === 0 ? 'Edifício Aurora' : 'Residencial Bosque Verde',
    tensaoEsperada: 30.2,
  })),
];

function DevPdfPreviewFichaRupturaPage() {
  const [comImagens, setComImagens] = useState(true);

  return (
    <div style={{ height: 'calc(100vh - 2rem)', display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
      <label style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', fontSize: '0.875rem' }}>
        <input type="checkbox" checked={comImagens} onChange={(e) => setComImagens(e.target.checked)} />
        Com logo/assinaturas de exemplo
      </label>
      <div style={{ flex: 1 }}>
        <PDFViewer key={String(comImagens)} width="100%" height="100%" showToolbar>
          <FichaRupturaPDF
            dataRuptura={dataRupturaMock}
            resultados={resultadosMock}
            empresas={empresasMock}
            obras={obrasMock}
            logoCliente={comImagens ? LOGO_EXEMPLO : null}
            assinaturas={comImagens ? [{ src: ASSINATURA_EXEMPLO, nome: 'Eng. Fulano de Tal' }, { src: ASSINATURA_EXEMPLO, nome: 'Eng. Beltrano da Silva' }] : []}
          />
        </PDFViewer>
      </div>
    </div>
  );
}

export default DevPdfPreviewFichaRupturaPage;
